<template>
  <div class="level">
    <LevelRow
      @toggle="openLab"
      :hasAccess="hasAccess"
      contentType="lab"
      :contentId="content.id"
      :labType="contentType"
      :status="contentStatus"
      :courseStatus="courseStatus"
      :title="title"
      :plansLink="plansLink"
      :isWatching="false"
      :details="labDetails"
      :textClass="textClass"
      :progress="progress"
      @click.native="openLab"
    >
    </LevelRow>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CONSTANTS from '@/constants'
import LevelRow from './level/LevelRow.vue'

export default {
  name: 'LabLevel',
  data() {
    return {
      isLoading: false,
    }
  },
  components: {
    LevelRow,
  },
  props: {
    courseId: {
      type: String,
      required: true,
    },
    courseStatus: {
      type: String,
      required: true,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
    content: {
      type: Object,
      required: true,
    },
    contentStatus: {
      type: String,
      required: true,
    },
    contentType: {
      type: String,
      required: true,
    },
    plansLink: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      focusedLabId: state => state.labs.focusedLabId,
    }),
    isLabFinished() {
      return (
        this.contentStatus &&
        this.contentStatus === CONSTANTS.CONTENT_USER_STATUS.FINISHED
      )
    },
    labDetails() {
      let status = ''
      status =
        this.content.session?.status === CONSTANTS.LABS.SESSION_STATUS.STARTED
          ? 'Lab running'
          : status
      status =
        this.content.session?.status === CONSTANTS.LABS.SESSION_STATUS.STOPPED
          ? 'Lab stopped'
          : status
      return status
    },
    textClass() {
      if (
        this.content.session?.status === CONSTANTS.LABS.SESSION_STATUS.STARTED
      )
        return 'green'
      if (
        this.content.session?.status === CONSTANTS.LABS.SESSION_STATUS.STOPPED
      )
        return 'red'
      return ''
    },
    progress() {
      if (this.contentStatus === CONSTANTS.CONTENT_USER_STATUS.STARTED) {
        return 50
      }
      if (this.contentStatus === CONSTANTS.CONTENT_USER_STATUS.FINISHED) {
        return 100
      }
      return 0
    },
  },
  methods: {
    async openLab() {
      if (this.hasAccess) {
        this.$emit('toggle-content', CONSTANTS.CONTENT_TYPES.LAB)
        const route = `${this.$route.name}-lab`
        this.$router.push({
          name: route,
          params: { labId: this.$props.content.id },
        })
      }
    },
  },
}
</script>
